export const COLUMNSINFO = [
  {
    accessorKey: "id",
  },
  {
    header: "Comienza",
    accessorKey: "_new_eventodecapacitacion_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Modalidad",
    accessorKey: "new_modalidaddecurso",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]

export const COLUMNSEVENTO = [
  {
    accessorKey: "id",
  },
  {
    header: "Carga horaria",
    accessorKey: "new_duracionenhoras",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Modalidad",
    accessorKey: "new_modalidaddecurso",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Sede/lugar",
    accessorKey: "new_sede",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha y hora de inicio",
    accessorKey: "new_fechainicio",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha y hora de fin",
    accessorKey: "new_fechafinalizacion",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]